import tabs from '../data/tabs';

export default {
    data() {
        return {
            tabs,
            selected: 0,
            star: {},
            list: [],
            p: 1,
            type: 0,
            count: 0
        }
    },

    watch:{
        '$route':'getId'
    },

    mounted() {
        this.getSearchInfo();
    },

    methods: {
        // 切换Tab
        changeTab(index) {
            this.selected = index;
            if(this.selected === 0) {
                this.type = 0
            }else if(this.selected === 3) {
                this.type = 1
            }
            this.getSearchInfo()
        },

        getId(){
            this.getSearchInfo()
        },

        // 获取搜索内容
        getSearchInfo() {

            this.list = []
            const loading = this.$loading({
                message: '查询中...'
            })
            let keyword = this.$route.query.keyword || '';
            this.$post('api.php/Home/searchSomething',{
                keywords: keyword,
                type: this.selected + 1,
                p: this.p
            }).then(res => {
                if (res.status == 1) {
                    this.count = res.data.count || 0;
                    this.list = res.data.list || [];
                }
            }).finally(()=>{
                loading.close();
            })
        }
    }
}
